import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {HeaderMenu} from "../../../model/headerMenu";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {NavigationService} from "../../../services/navigation-service";
import {IconComponent} from "../icon/icon.component";
import {Icons} from "../../../model/icon";
import {SectionService} from "../../../services/section-service";
import {HeightService} from "../../../services/height-service";

@Component({
  selector: 'app-menu',
    imports: [
        NgForOf,
        NgClass,
        IconComponent
    ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent implements OnInit{
    constructor(private router: Router,
                private route: ActivatedRoute,
                private navigation: NavigationService,
                public sectionService: SectionService,
                private heightService: HeightService,) {}

    @Output() clickOn = new EventEmitter();

  elements: HeaderMenu[] = [
      {
          title: 'О проекте',
          bg: 'app/assets/about-new.jpg',
          url: '',
          position: 'title'
      },
      {
          title: 'Карта',
          bg: 'app/assets/map.jpg',
          url: 'map',
      },
      {
          title: 'Хронология',
          bg: 'app/assets/chrono.jpg',
          url: 'chronology'
      },
      {
          title: 'Герои',
          bg: 'app/assets/heroN.JPG',
          url: 'heroes'
      },
      {
          title: 'Статьи',
          bg: 'app/assets/highway.jpg',
          url: 'article'
      },
      {
          title: 'Победа в интересных фактах',
          bg: 'app/assets/win.jpg',
          url: 'fact'
      },
      {
          title: 'Стать автором',
          bg: 'app/assets/bg/bg.png',
          url: '',
          position: 'footer',
      },
  ];

  background: string = 'app/assets/bg/bg.png';
  page: string = '';
  isBackground: boolean = false;

  ngOnInit() {

  }

    onMouseEnter(str: string) {
      this.background = str;
    }

    onMouseLeave() {
      this.background = '';
    }

    setBackground() {
      return `background-image: url("${this.background}");`;
    }

    navigate(el: HeaderMenu) {
        // this.navigation.setNavigationPos(el.position ?? '');
        // this.router.navigate([el.url]).then(r => r);
        // this.clickOn.emit(false);

        if (el.position !== undefined) {
            this.clickOn.emit(el.title);
            this.router.navigate(['/']).then(r => r);
            setTimeout(() => {
                if (el.position == 'title') {
                    window.scrollTo(0, 0);
                }
                if (el.position == 'footer') {
                    const down = (document.body.scrollHeight || document.documentElement.scrollHeight) -
                        this.heightService.getActiveHeight();
                    window.scrollTo(0, down);
                }
            }, 300);
            // this.scrollToSection(el.position);
        } else {
            this.clickOn.emit(el.title);
            this.router.navigate([el.url]).then(r => r);
        }
    }

    scrollToSection(sectionId: string) {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

    protected readonly Icons = Icons;
}
